// @flow

// Vendors
import React from 'react';

// Components
import ProductGridItem from './ProductGridItem';

// Types
import { ProductType } from '../../types';
type Props = {
  products: Array<ProductType>
};

const ProductsGrid = ({ products }: Props) => (
  <div className="grid grid--gutter-vertical">
    {products.map(product => (
      <ProductGridItem key={product.id} product={product} />
    ))}
  </div>
);

export default ProductsGrid;
